<template>
    <div class="categ_block">
        <div class="panel-tag">
            {{ __t('REST_FILTER_CATEG_INFO') }}
        </div>

        <div class="categ_list p-3">
            <categlist
                @change="set_active_categ"
                :categories="categories"
            />
        </div>
    </div>
</template>

<script>
import Categlist from "../../../../../catalog/categories/list/categlist";

export default {
    name: "receiver_categories",

    components: {
        Categlist
    },

    props: {
        receiver: {
            type: Object,
            required: true
        },

        restaurant: {
            type: Object,
            required: true
        },

        used_ids: {
            type: Array,
            default: function () {
                return []
            }
        }
    },

    data() {
        return {
            categories: [],
            is_load: false,
        }
    },

    created() {
        if (!this.receiver.hasOwnProperty('categs')) {
            this.$set(this.receiver, 'categs', [])
        }

        this.load_categories()
    },

    methods: {
        set_active_categ(categ) {
            let cur_ids = [...this.active_ids]
            let id = parseInt(categ.id)

            if (id <= 0) {
                return
            }

            if (categ.is_active === true) {
                if (this.used_ids.includes(id)) {
                    categ.is_active = false
                    this.$emit('duplicate')
                    return
                }

                if (!cur_ids.includes(id)) {
                    cur_ids.push(id)
                }
            } else {
                let index = cur_ids.indexOf(id)

                if (index >= 0) {
                    cur_ids.splice(index, 1)
                }
            }

            this.active_ids = cur_ids
            this.set_categories_attr(this.categories)
        },

        async load_categories() {
            this.categories = []
            this.is_load = true

            await api.post('/internal/v1/catalog/categories/tree', {
                org_id: this.restaurant.parent_id,
                provider_filter: 'pwa'
            }).then(({data}) => {
                this.is_load = false

                if (data.status === "operation_success") {
                    let categories = data.data
                    this.set_categories_attr(categories)
                    this.categories = categories
                }
            }).catch(({response}) => {
                this.is_load = false

                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            })
        },

        set_categories_attr(categories) {
            categories.map(item => {
                let id = parseInt(item.id)

                item.is_active = this.active_ids.includes(id)

                /**
                 * Важно:
                 * если категория уже выбрана в другом receiver,
                 * то визуально оставляем её неактивной.
                 *
                 * Если твой categlist поддерживает disabled,
                 * можно использовать item.disabled.
                 */
                item.disabled = this.used_ids.includes(id)

                if (item.hasOwnProperty("children")) {
                    this.set_categories_attr(item.children)
                }
            })
        }
    },

    computed: {
        active_ids: {
            get: function () {
                if (this.receiver && this.receiver.categs) {
                    return this.receiver.categs
                }

                return []
            },

            set: function (val) {
                this.$set(this.receiver, 'categs', val)
            }
        }
    },

    watch: {
        used_ids: {
            deep: true,
            handler() {
                this.set_categories_attr(this.categories)
            }
        }
    }
}
</script>

<style scoped>

</style>
